import { render } from "./CenteredContent.vue?vue&type=template&id=06bc1bf0"
import script from "./CenteredContent.vue?vue&type=script&lang=js"
export * from "./CenteredContent.vue?vue&type=script&lang=js"
script.render = render

export default script